import { useAppVersionContext } from '@/contexts/AppVersionContext';

/**
 * Hook to access app version state
 *
 * This hook now uses the AppVersionContext singleton to prevent
 * duplicate AppState listeners and multiple version checks.
 *
 * All components using this hook share the same state.
 */
export function useAppVersion() {
  return useAppVersionContext();
}
